import { render, staticRenderFns } from "./unassigned_customer_list.vue?vue&type=template&id=9e1a4572&scoped=true&"
import script from "./unassigned_customer_list.vue?vue&type=script&lang=js&"
export * from "./unassigned_customer_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1a4572",
  null
  
)

export default component.exports